var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(_setup.FormPublishBtn, {
        staticClass: "mb-3",
        attrs: { "form-id": _vm.formId },
      }),
      _vm._v(" "),
      _c(_setup.FormCreatedModified, { attrs: { "form-id": _vm.formId } }),
      _vm._v(" "),
      _setup.showDisplayOrderOption && _setup.currentData.id
        ? _c(_setup.FormDisplayOrderMenu, {
            staticClass: "mb-2",
            attrs: { "form-id": _vm.formId },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showHistoryBtn
        ? _c(_setup.FormHistoryBtn, { attrs: { "form-id": _vm.formId } })
        : _vm._e(),
      _vm._v(" "),
      _vm.showDuplicateBtn
        ? _c(_setup.FormDuplicateBtn, { attrs: { "form-id": _vm.formId } })
        : _vm._e(),
      _vm._v(" "),
      _c(_setup.TagsBtn, { attrs: { "form-id": _vm.formId } }),
      _vm._v(" "),
      _c(_setup.OrderRequestReview, { attrs: { "form-id": _vm.formId } }),
      _vm._v(" "),
      _c(_setup.PrintBtn, {
        attrs: { "form-id": _vm.formId, "is-invoice": true },
      }),
      _vm._v(" "),
      _c(_setup.PrintBtn, { attrs: { "form-id": _vm.formId } }),
      _vm._v(" "),
      _c(_setup.PageEditorDetachFromPageBtn, {
        attrs: { "form-id": _vm.formId },
      }),
      _vm._v(" "),
      _vm.showArchiveBtn
        ? _c(_setup.FormArchiveBtn, { attrs: { "form-id": _vm.formId } })
        : _vm._e(),
      _vm._v(" "),
      _c(_setup.FormDeleteBtn, {
        attrs: {
          "form-id": _vm.formId,
          "always-show": _vm.alwaysShowDeleteBtn,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }